import React from "react";
import Blurb from "Signups/SharedComponents/MarketingBlurb";

export default function FamilyRegMarketingBlurb() {
  return (
    <Blurb.Container>
      <Blurb.Title>
        <Blurb.Icon className="far fa-id-card"></Blurb.Icon>
        <h2 data-cy="famRegMarketingBlurbHeader">
          Why use Family & Visitor Registration
        </h2>
      </Blurb.Title>

      <ul>
        <li>Give families one easy place to provide and update their info</li>
        <li>Create a connection card to help visitors get involved</li>
        <li>
          Collect everything you need:
          <ul>
            <li>Contact info</li>
            <li>Family relationships</li>
            <li>Birthdays</li>
            <li>Household status</li>
            <li>And more!</li>
          </ul>
        </li>
        <li>
          Members can even set up a recurring gift, request giving envelopes, join your groups, and more!
        </li>
      </ul>
    </Blurb.Container>
  );
}
